// 首頁、連載首頁、漫畫首頁
import axios from 'axios'
import {API_URL} from './config.js'
//
export default {
  getSlider: function (adgroup = 0, cb) {
    let params = {
      adgroup: adgroup
    }
    axios.get(`${API_URL}/AD/Slider/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      this.slides = response.data.ADs
      if (typeof cb !== 'undefined') cb()
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
        if(this.adBlockIsOpen){
          window.location.hash="alert4"
        }else{
          alert(e.message)
        }
    })
  },
  getSpecialEdit: function (adgroup) {
    let params = {
      adgroup: adgroup
    }
    axios.get(`${API_URL}/AD/SliderM/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      const myData = response.data
      for(var i=0;i<myData.length;i++){
        if(myData[i].Link === null || myData[i].Link ===undefined){
          myData[i].Link={
            "LinkURL": "#",
            "Blank": true
          }
        }
      }
      // console.log("myData="+myData)
      this.specialEditSlides = myData
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  getSliderM: function () {
    axios.get(`${API_URL}/SpecialEdit/Slider`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log(response)
      this.slidesM = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
        if(this.adBlockIsOpen){
          window.location.hash="alert4"
        }else{
          alert(e.message)
        }
    })
  },
  getBanner: function (adgroup) {
    let params = {
      adgroup: adgroup
    }
    axios.get(`${API_URL}/AD/Banner/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      this.Banner = response.data
      // JSON responses are automatically parsed.
      // console.log(response)
    }).catch(e => {
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  getSellShelf: function (nodeid = 1) {
    let params = {
      nodeid: nodeid
    }
    axios.get(`${API_URL}/SellShelf/${this.getParams(params, false)}`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log('getSellShelf')
      this.sellShelfs = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  getSellShelfMore: function (booksetid, page,pageSize=20) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/SellShelf/${booksetid}/${page}?pageSize=`+pageSize, this.getBearerToken()).then(response => {
        // JSON responses are automatically parsed.
        // console.log("getSellShelfMore",response)
        this.books = response.data.Books
        resolve(response.data)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        // if(this.adBlockIsOpen){
        //   window.location.hash="alert4"
        // }else{
        //   alert(e.message)
        // }
      })
    })
  },
  getSalesRanking: function (type, summary) {
    let params = {
      type: type
    }
    axios.get(`${API_URL}/SellRanking/${this.getParams(params, false)}`, this.getParams(params), this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      this.salesRanking = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  getNewsList: function () {
    axios.get(`${API_URL}/News/List`, this.getBearerToken()).then(response => {
      // JSON responses are automatically parsed.
      // console.log('getNewsList')
      this.newsList = response.data
      // console.log(this.newsList)
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  //0907新增- Fa <首頁tag列表>
  getAllTag: function(){
    axios.get(`${API_URL}/Tag/All`, this.getBearerToken()).then(response =>{
      // this.tags = response.data
      var _layout = ""
      for(var i=0 ; i<response.data.length ;i++){
        if(response.data[i].Count != 0){
          /* 有數字版本 */
          //<div class="hashtag" id="'+response.data[i].Name+'"><img class="hashtag-img-home" src="../images/tag.svg" /><span>'+response.data[i].Name+'('+response.data[i].Count+')</span></div>\
          _layout += '<a>\
                        <div class="hashtag" id="'+response.data[i].Name+'"><img class="hashtag-img-home" src="../images/tag.svg" /><span>'+response.data[i].Name+'</span></div>\
                      </a>'
        }
      }
      $(".hashtag_bottom_wrap").append(_layout);
      $(".hashtag").on("click",function() {
        window.location.href = (window.location.origin+"/search?query=searchTag"+encodeURIComponent(this.id))
      });
    }).catch(e => {
      if(this.adBlockIsOpen){
        window.location.hash="alert4"
      }else{
        alert(e.message)
      }
    })
  },
  //0918火力新增
  getLink (slide) {
    if (slide.NodeAction) {
      switch (slide.NodeAction.Action) {
        case 'News':
          return `/news_content?id=${slide.NodeAction.Parm}`
          break
        case 'Book':
          return `/book?id=${slide.NodeAction.Parm}&isGroup=false`
          break
        case 'BookGroup':
          if(window.location.pathname=="/serials"){
            return `/book?id=${slide.NodeAction.Parm}&isGroup=true&isSerials=true`
          }else{
            return `/book?id=${slide.NodeAction.Parm}&isGroup=true&isSerials=false`
          }
          break
        case 'SpecialEdit':
          return `/topic?id=${slide.NodeAction.Parm}`
          break
        case 'Link':
          return slide.Link ? `${slide.Link.LinkURL}` : ''
          break
      }
    } else {
      return '#'
    }
  },
  checkLink (slide) {
    if (slide && slide.NodeAction.Action === 'Link' && !slide.Link) {
      alert("點擊的 slide 沒有提供連結，請聯絡管理員！")
    }
  },
  //熱門關鍵字
  getSearchHot(){
    axios.get(`${API_URL}/Search/Hot`, this.getBearerToken()).then(response =>{
      var _layout = ""
      let searchHot = $("#searchHot")
      for(var i=0;i<response.data.length;i++){
        _layout += '\
        <li><a href="'+window.location.origin+"/search?query="+encodeURIComponent(response.data[i])+'">'+response.data[i]+'</a></li>\
        '
      }
      searchHot[0].innerHTML = _layout
    }).catch(e => {
      console.log(e.message)
    })
  },
  //檢查adBlock
  checkAdblock(){
    axios.get("/js/ads.js").then(response =>{
      console.log("block ok")
    }).catch(e => {
      console.log("ad block is open",e)
      this.adBlockIsOpen = true
    })
  }
}


// WEBPACK FOOTER //
// ./src/home.js